import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { APP_VERSION } from '@core/constants/platform/app-version.token';

@Component({
  selector: 'gg-version-renderer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './version-renderer.component.html',
  styleUrls: ['./version-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionRendererComponent {
  constructor(@Inject(APP_VERSION) public appVersion: string) {}
}
